module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/faceMask@2x_c6be94.png";